import * as React from 'react';
import classnames from 'classnames';
import { Hr } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { FacetPickerHeader } from '../../../FacetPickers/components/FacetPickerHeader.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '../../../../../../context/actions.js';
import '../../../../../../context/reducer.js';
import '../../../../../../types/product.js';
import '../../../../../../context/ProductContext.js';
import '../../../../../../context/CmsContext.js';
import '@grandvisionhq/analytics';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/icons';
import '@swc/helpers';
import '@grandvisionhq/forms';

const SingleVariantNode = ({ facetConfig , facetTerm , rightSlot , className  })=>{
    const { getLabel  } = useIntl();
    const { titleLabelKey , titleLabelKeySingle , showSingleFacetAs  } = facetConfig;
    const title = getLabel(titleLabelKeySingle ? titleLabelKeySingle : titleLabelKey);
    const SingleFacetFormatter = facetConfig.singleFacetFormatter;
    const singleFacetTerm = SingleFacetFormatter ? /*#__PURE__*/ React.createElement(SingleFacetFormatter, {
        facetTerm: facetTerm
    }) : /*#__PURE__*/ React.createElement("div", null, facetTerm);
    if (showSingleFacetAs === 'none' && !rightSlot) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: classnames('single-variant-node', className)
    }, showSingleFacetAs === 'text-with-heading' && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FacetPickerHeader, {
        rightSlot: rightSlot
    }, title), singleFacetTerm), showSingleFacetAs === 'text-without-heading' && /*#__PURE__*/ React.createElement("div", {
        className: "single-variant-node__without-heading"
    }, singleFacetTerm, rightSlot), showSingleFacetAs === 'none' && rightSlot), /*#__PURE__*/ React.createElement(Hr, null));
};

export { SingleVariantNode };
//# sourceMappingURL=SingleVariantNode.js.map
